
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M8 4a1 1 0 0 0-1 1v3a1 1 0 0 0 .293.707l2 2a1 1 0 0 0 1.414-1.414L9 7.586V5a1 1 0 0 0-1-1Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8 1a7.009 7.009 0 0 0-7 7v2.4a.25.25 0 0 0 .427.177l3.146-3.15A.25.25 0 0 0 4.4 7H3.1A5 5 0 1 1 8 13a4.957 4.957 0 0 1-3.6-1.532 1 1 0 1 0-1.441 1.386A6.937 6.937 0 0 0 8 15 7 7 0 0 0 8 1Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  